

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },

    /**
     * determines the width of the button component
     * @values inline, block
     */
    size: {
      /** @type {'inline'|'block'} */
      type: String,
      default: 'inline',
      validator: value => ['inline', 'block'].includes(value)
    },

    icon: {
      /** @type {AlturaIcons} */
      type: String,
      default: undefined
    },

    iconAlign: {
      /** @type {"left"|"right"|"start"|"end"} */
      type: String,
      default: 'start',
      validator: val => ['left', 'right', 'start', 'end'].includes(val)
    },

    /**
     * How big the icon should be in fractions
     */
    iconSize: {
      type: [Number, String],
      default: 1
    },

    active: {
      type: Boolean,
      default: undefined
    },

    appearance: {
      type: String,
      default: 'button',
      validator: val => ['button', 'text', 'none'].includes(val)
    },

    disableFill: {
      type: Boolean
    },

    disableIconToggle: {
      type: Boolean
    }
  },
  data () {
    return {
      internalActive: this.active ?? this.value,
      internalValue: this.value
    };
  },
  computed: {
    currentIcon () {
      if (this.disableIconToggle) {
        return this.icon;
      }

      if (this.icon === 'plus' && this.internalActive) { return 'minus'; }

      if (this.icon.includes('left') && this.internalActive) { return this.icon.replace('left', 'right'); }

      if (this.icon.includes('right') && this.internalActive) { return this.icon.replace('right', 'left'); }

      if (this.icon.includes('up') && this.internalActive) { return this.icon.replace('up', 'down'); }

      if (this.icon.includes('down') && this.internalActive) { return this.icon.replace('down', 'up'); }

      if (this.icon.includes('open') && this.internalActive) { return this.icon.replace('open', 'closed'); }

      if (this.icon.includes('closed') && this.internalActive) { return this.icon.replace('closed', 'open'); }

      if (this.icon === 'check' && !this.internalActive) { return 'close'; }

      if (this.icon === 'expand' && this.internalActive) { return 'collapse'; }

      if (this.icon === 'check-circle' && !this.internalActive) { return 'close-circle'; }

      return this.icon;
    },

    classes () {
      return [
        this.appearance,
        `icon-${this.iconAlign}`,
        {
          'icon-only': !!this.icon && Object.keys(this.$slots).length === 0,
          'has-icon': this.icon,
          active: this.internalActive,
          block: this.size === 'block'
        }
      ];
    }
  },

  watch: {
    value () {
      this.internalValue = this.value;

      if (this.active === undefined) { this.internalActive = this.internalValue; }
    },
    active () {
      this.internalActive = this.active;
      this.internalValue = this.active;
    }
  },
  methods: {
    click () {
      this.toggle();
    },

    toggle (e) {
      this.internalValue = !this.internalValue;
      this.$emit('input', this.internalValue);
      this.$emit('click', e);

      if (!this.internalValue) { this.$emit('deactivated'); } else { this.$emit('activated'); }

      if (this.active === undefined) { this.internalActive = this.internalValue; }
    }
  }
};
